import React from "react";

export default function ColoredBar({
    hoveredBrand = null,
    brands = [],
    className = "",
}) {
    // Função que retorna o estilo de gradiente com paradas de cor customizadas
    const customBehubGradient =
        "bg-[linear-gradient(to_right,_#4B3BDB_0%,_#910CCE_8%,_#A002CB_94%,_#FC0021_100%)]";
    const customNex2aiGradient =
        "bg-[linear-gradient(to_right,_#4B3BDB_0%,_#A002CB_8%,_#FC0021_16%,_#FC0021_86%,_#A002CB_92%,_#4B3BDB_100%)]";
    const customOmnicoreGradient =
        "bg-[linear-gradient(to_right,_#FC0021_0%,_#A002CB_8%,_#4B3BDB_16%,_#4B3BDB_86%,_#A002CB_92%,_#FC0021_100%)]";

    const getBarColor = () => {
        if (!hoveredBrand) {
            return "bg-gradient-to-r from-[#4B3BDB] via-[#BC3FE5] to-[#FC0021]";
        }

        const brand = brands.find((b) => b.id === hoveredBrand);
        if (!brand)
            return "bg-gradient-to-r from-[#4B3BDB] via-[#BC3FE5] to-[#FC0021]";

        if (brand.id === "omnicore") return customOmnicoreGradient;
        if (brand.id === "behub") return customBehubGradient;
        if (brand.id === "nex2ai") return customNex2aiGradient;
        if (brand.id === "projectiva") return "bg-[#331175]";
        return "bg-gradient-to-r from-[#4B3BDB] via-[#BC3FE5] to-[#FC0021]";
    };

    return (
        <div
            className={`w-full h-2 transition-all duration-500 ${className} overflow-hidden`}
        >
            <div
                className={`w-full h-full ${getBarColor()} transition-all duration-300`}
            ></div>
        </div>
    );
}
